<template>
  <v-card width="100%">
    <management-nav />
    <v-card-title>
      Dostępne subskrypcje miesięczne
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Szukaj" single-line hide-details
        ><font-awesome-icon icon="search" slot="prepend-inner" class="mr-1 mt-1"
      /></v-text-field>
    </v-card-title>
    <v-data-table
      :loading="!items"
      loading-text="Trwa pobieranie danych..."
      :headers="headers"
      :items="items"
      :search="search"
    >
      <template v-slot:no-data>
        <v-alert :value="items && items.length === 0">
          Brak subskrypcji
        </v-alert>
      </template>
      <template v-slot:[`item.packageItems`]="{ item }">
        <div v-for="link in item.packageItems" :key="link.id">
          {{ link.link }}
        </div>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="green"
              @click="editPackage(item)"
              v-bind="attrs"
              v-on="on"
              v-on:click="isModalVisible = true"
            >
              <font-awesome-icon icon="edit" />
            </v-btn>
          </template>
          <span>Edytuj</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="red"
              v-bind="attrs"
              v-on="on"
              v-on:click="(isDeleteModalVisible = true), (currentItem = item)"
            >
              <font-awesome-icon icon="times" />
            </v-btn>
          </template>
          <span>Usuń</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.description`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <p
              :id="item.id"
              v-bind="attrs"
              v-on="on"
              v-html="htmlToFormattedText(item.description)"
            />
          </template>
        </v-tooltip>
      </template>
        <template v-slot:[`item.discount`]="{ item}" >
            <template v-if="item.discountCodes && item.discountCodes.length > 0">
            <p v-for="discountCode in item.discountCodes" :key="discountCode.id">
              <b>{{discountCode.code}}</b> ({{`${(discountCode.value * 100).toFixed()}%`}})
            </p>
            </template>
            <template v-else>
              Brak
            </template>

      </template>

    </v-data-table>
    <AddTimePackageModal
      :isVisible="isModalVisible"
      :packageData="packageData"
      @closeModal="closeModal()"
      :withDiscount="true"
      :timePackageType="'FOR-BEGINNERS'"
      @timePackageUpdated="refreshList"
    />
    <BeforeDeleteModal
      :isVisible="isDeleteModalVisible"
      @closeModal="closeDeleteModal()"
      @confirmDeletion="confirm(currentItem.id)"
    />
    <v-btn
      fab
      dark
      large
      color="green"
      fixed
      left
      bottom
      v-on:click="isModalVisible = true"
    >
      <font-awesome-icon icon="plus" />
    </v-btn>
  </v-card>
</template>

<script>
import AddTimePackageModal from "../components/modals/AddTimePackageModal";
import ManagementNav from "../components/ManagementNav.vue";
import BeforeDeleteModal from "../components/modals/BeforeDeleteModal.vue";
export default {
  name: "SubscriptionsForBeginnersManagement",
  components: {
    AddTimePackageModal,
    ManagementNav,
    BeforeDeleteModal,
  },
  created() {
    this.$store.dispatch("timePackages/fetchAllTimePackages", {
      type: "FOR-BEGINNERS",
    });
    this.$store.dispatch("movieSubCategories/fetchAll");
  },
  data: () => ({
    headers: [
      { text: "Nazwa pakietu", value: "name" },
      { text: "Zniżki", value: "discount" },
      { text: "Opis pakietu", value: "description" },
      { text: "Cena", value: "price" },
      { text: "Ilość dni", value: "numberOfDays" },
      { text: "Akcje", value: "actions", sortable: false },
    ],
    search: "",
    isModalVisible: false,
    packageData: null,
    currentItem: null,
    isDeleteModalVisible: false,
  }),
  computed: {
    items() {
      return this.$store.getters["timePackages/getAllTimePackages"];
    },
  },
  methods: {
    refreshList(){
      this.$store.dispatch("timePackages/fetchAllTimePackages", {
      type: "FOR-BEGINNERS",
    });
    },
    htmlToFormattedText(text) {
      const regex = /((http|https|ftp|ftps):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(\/\S*)?)/g;
      text = text.replace(regex, '<a href="$1">$1</a>');
      return text;
    },
    editPackage(data) {
      this.packageData = data;
    },
    deletePackage(id) {
      this.$store.dispatch("timePackages/deletePackage", {
        id,
        type: "FOR-BEGINNERS",
      });
    },

    confirm(id) {
      this.deletePackage(id);
    },
    closeDeleteModal() {
      this.isDeleteModalVisible = false;
      this.packageData = null;
      this.currentItem = null;
    },

    closeModal() {
      this.isModalVisible = false;
      this.packageData = null;
      this.currentItem = null;
    },
  },
};
</script>

<style></style>
